<template>
  <van-field
    class="date-picker"
    v-bind="$attrs"
    v-on="$listeners"
    :border="false"
  >
    <template #input>
      <input
        class="date-picker-input"
        type="date"
        v-model="inputValue"
        :disabled="disabled"
        :class="{ 'placeholder-style': disabled }"
        @change="inputEvent"
      />
    </template>
    <template #right-icon>
      <van-icon
        class="date-picker-arrow"
        :class="{ 'placeholder-style': disabled }"
        name="arrow-down"
      />
    </template>
  </van-field>
</template>

<script>
export default {
  name: 'DataPicker',
  mixins: ['update:value', 'change'],
  props: {
    value: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.inputValue = newValue;
    }
  },
  methods: {
    inputEvent(e) {
      const value = e.target?.value;
      this.$emit('change', value);
      this.$emit('update:value', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.date-picker {
  position: relative;
  box-sizing: border-box;
  padding: 0 22px 0 20px;
  background-color: var(--block-bg-light-color);
  border-radius: var(--border-radius);

  &-input {
    position: relative;
    width: 100%;
    height: 100px;
    font-size: 24px;
    color: var(--text-color);
    background-color: transparent !important;
    // 去掉背景色（有年月日部分）
    &::-webkit-datetime-edit {
      background: transparent;
    }
    // 去掉背景色（年月日后面部分）
    &::-webkit-datetime-edit-fields-wrapper {
      background-color: transparent;
    }
    &::-webkit-calendar-picker-indicator {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      outline: none;
      background-color: transparent;
    }

    &:disabled {
      color: var(--placeholder-color) !important;
      -webkit-text-fill-color: var(--placeholder-color) !important;
    }
  }
  &-arrow {
    font-size: 24px;
    font-weight: bold;
    color: var(--text-color);
  }
  .placeholder-style {
    color: var(--placeholder-color) !important;
  }
  ::v-deep .van-field__label {
    display: flex;
    align-items: center;
    width: unset;
    min-width: 194px;
    font-size: 24px;
    color: var(--text-color);
  }
}
</style>
